import {
  GoFavButton,
  IconHolder,
  Block,
  SubContent,
  TempFaves,
  TitleHolder,
  UI
} from "./FavouriteUI.style"
import { useHistory } from "react-router-dom"
import { useSpring } from "react-spring"
import { FavouriteIcon } from "../../../ApartmentFinderConfig/Icons/DynamicIcons"

import {
  useApartmentBedsByPlotNumber,
  useApartmentFloorLevelByPlotNumber,
  useBlockIDbyPlotNumber
} from "../Utils/hooks"
import FavouriteBookmark from "../../../ApartmentFinderConfig/Icons/FavouriteBookmark"
import { blockInfo } from "../../../ApartmentFinderConfig/blockInfo"
import { zeroPad } from "../../../utils/utils"
import parse from "html-react-parser"
import { useStore } from "../../../state/store"

const bedsTypes = {
  1: "ONE",
  2: "TWO",
  3: "THREE",
  4: "FOUR"
}
export default function FavouriteUI() {
  const history = useHistory()
  const favourites = useStore(state => state.favourites)
  const favouritesActive = useStore(state => state.favouritesActive)
  const setFavouritesActive = useStore(state => state.setFavouritesActive)
  const setActiveApt = useStore(state => state.setActiveApt)
  const activeBlock = useStore(state => state.activeBlock)
  const setActiveFloors = useStore(state => state.setActiveFloors)
  const apartmentFinderActive = useStore(state => state.apartmentFinderActive)
  const removeFavourite = useStore(state => state.removeFavourite)

  const blockIDs = useBlockIDbyPlotNumber()

  const beds = useApartmentBedsByPlotNumber()
  const floor = useApartmentFloorLevelByPlotNumber()

  const springStyle = useSpring({
    top: favouritesActive ? 0 : -window.innerHeight * 2.5
  })

  const toggleFavourites = () => {
    if (apartmentFinderActive) {
      setFavouritesActive(!favouritesActive)
      setActiveApt(null)
      if (Object.keys(blockInfo).includes(activeBlock)) {
        setActiveFloors(blockInfo[activeBlock].habitableFloors.length - 1)
      }
    } else {
      history.push("/favourites")
    }
  }

  return (
    <>
      <IconHolder onClick={toggleFavourites}>
        <FavouriteBookmark callback={toggleFavourites} />
      </IconHolder>
      <GoFavButton visible={favouritesActive} to={"/favourites"}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 226.92 215.77">
          <g id="Map_Icons" data-name="Map Icons">
            <circle
              cx="113.46"
              cy="107.89"
              r="95.93"
              fill="#7b918e"
              stroke="#7b918e"
              strokeMiterlimit="10"
            />
            <circle
              cx="113.46"
              cy="107.89"
              r="104.41"
              fill="none"
              stroke="#7b918e"
              strokeMiterlimit="10"
              strokeWidth="4"
            />
            <path
              d="M166.15,102.72v-.06a10.52,10.52,0,0,0-10.5-10.75,9.07,9.07,0,0,0-8.84,6.68.62.62,0,0,1-.59.42.61.61,0,0,1-.59-.42,9.07,9.07,0,0,0-8.84-6.68,10.52,10.52,0,0,0-10.5,10.72v.09c0,1.42.19,14,19.93,24.35,19.74-10.36,20-22.93,19.93-24.33Z"
              fill="none"
              stroke="#fdfdfd"
              strokeMiterlimit="10"
              strokeWidth="2"
            />
            <path
              d="M93.16,147.54a1.52,1.52,0,0,1-1.08-.45L54,109a1.52,1.52,0,0,1,0-2.16L92.08,68.68a1.54,1.54,0,0,1,2.16,0,1.52,1.52,0,0,1,0,2.16l-37,37.05,37.05,37.05a1.53,1.53,0,0,1-1.08,2.6Z"
              fill="#fdfdfd"
            />
            <path
              d="M119.05,147.54a1.52,1.52,0,0,1-1.08-.45L79.84,109a1.54,1.54,0,0,1,0-2.16L118,68.68a1.53,1.53,0,0,1,2.16,2.16l-37,37.05,37.05,37.05a1.53,1.53,0,0,1-1.08,2.6Z"
              fill="#fdfdfd"
            />
          </g>
        </svg>
      </GoFavButton>
      <UI style={springStyle}>
        {favourites.map((id, i) => (
          <TempFaves key={i} onClick={() => setActiveApt(id)}>
            <Block>
              {parse(blockIDs[id].includes("E") ? `Manuscript<br/>Court` : `Fold<br/>House`)}
            </Block>
            <TitleHolder>
              <h1>Level {zeroPad(floor[id], 2)}</h1>
              <h2>{blockIDs[id]}</h2>
              <h3>{bedsTypes[beds[id]]} BED</h3>
            </TitleHolder>
            <SubContent>
              <div
                onClick={e => {
                  e.stopPropagation()
                  removeFavourite(id)
                }}
                style={{
                  height: "40px",
                  width: "40px",
                  margin: "30%",
                  marginTop: "50%",
                  transform: "translate(0, -50%)",
                  pointerEvents: "initial"
                }}
              >
                <FavouriteIcon isFavourite={true} />
              </div>
            </SubContent>
          </TempFaves>
        ))}
      </UI>
    </>
  )
}
